import { AppState } from "./types";
import { Animation, CanvasResolution } from "./types";
import { aspectToPixel  } from "../History/ResponsiveUtilities";
import { randomColorPallete } from "./colorPalette";
import { BrushItems } from "./Brushes";
import chroma from "chroma-js";
import { getWindowDimensions } from '../Context/SizingContext'

export const resolutions: CanvasResolution[] = [
  {
    aspectRatio: 2,
    name: "Landscape",
    description: "Great for Facebook!",
  },
  {
    aspectRatio: 1.7,
    name: "Standard Screen Size",
    description: "Makes for a great computer background!",
  },
  {
    aspectRatio: 1,
    name: "Square",
    description: "Perfect for Instagram!",
  },
];

export const ColorTheme = {
  background: "#011638",
  primary: "#C2C2C2",
  primaryText: "#141414",
  contrastBackground: "#C962AB",
  secondaryBackground: "#F2C190",
};

export const menuID = {
  NewCanvas: "resolutionSelect",
  SideColorBar: "sideColorBar",
  DesktopBrush: "desktopBrush",
  MobileBrush: "mobileBrush",
  HistoryContainer: "historyContainer",
  LoadScreen: "loadScreen",
  TopBrushMenu: "topBrush",
};
export const HISTORY_LENGTH = 100;
export const seedBrush =
  BrushItems[Math.floor(Math.random() * BrushItems.length)].brushType;

const randColor = chroma.random().rgb();
const initialBrushColor = [`rgb(${randColor[0]},${randColor[1]},${randColor[2]})`] 
const initialColorPallette = randomColorPallete();
export const initialBrushSpeed = 40

console.info("initialColorPallette = " + JSON.stringify( initialColorPallette))
export const initState: AppState = {
  activeBrush: seedBrush,
  brushPlaybackRate: 0.1,
  animation: Animation.None,
  cachedColorData: {
    data: { alpha: 1, darkness: 0, variations: 25 },
    color: initialColorPallette,
  },
  isPaletteUsed: false,
  colorIsAnimated: true,
  currentActiveMenu: "spring",
  brushColor: initialBrushColor,
  brushCount: 3,
  brushIsAnimated: true,
  brushSpeed: initialBrushSpeed,
  brushType: "spring",
  brushSize: 25,
  CanvasSizeData: resolutions[0],
  colorTransitionSpeed: 0.1,
  colorBarIsCollapsed: true,
  brushbarIsCollapsed: true,
  dimensions: aspectToPixel(1.7, getWindowDimensions()),
  drawnOnMobile: true,
  globalColorData: { alpha: 1, darkness: 0, variations: 25 },
  growShrink: "grow",
  height: 0,
  imageModalOpen: false,
  isColorfillMode: false,
  isColorSelect: false,
  images: {},
  penPath: 0,
  penRadius: 50,
  penSpeed: 20,
  shapeSettings: {
    shape: 0,
    shapeSize: 200,
    shapeRotation: "drag",
  },
  shapeImages: [],
  userSessionData: {
    session: undefined,
    images: [],
  },
  width: 0,
  wipeCount: 8,
  wipeDirection: "bottom",
  wipeSpeed: 0,
  wipeSpan: 250,
  history: {
    performRedo: false,
    performUndo: false,
    maxHistoryLength: HISTORY_LENGTH,
    historyLength: 0,
    historyPos: 0,
  },
};
